export default function setLegacyChecklistCompletionProgress(isComplete: boolean) {
  return isComplete ? 100 : 0;
}
